module.exports = __webpack_public_path__ + "media/images/captive_portal/Calendar-7e14ade7493f8df0a62bcf693928c9e7.svg";